import { render, staticRenderFns } from "./PortalCheckbox.vue?vue&type=template&id=64e77fa0&scoped=true&"
import script from "./PortalCheckbox.vue?vue&type=script&lang=ts&"
export * from "./PortalCheckbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e77fa0",
  null
  
)

export default component.exports